<template>
  <div class="regional-challenges-page">
    <WeCircularNavbar />

    <section class="page-section hero-section">
      <div class="page-container">
        <h1 class="page-title">Regional challenges</h1>

        <p class="page-intro">
          This section explores regional challenges in the Danube Region through the lens of women-led enterprises,
          digitalization, the circular economy, and Smart Specialisation Strategies (S3), with a focus on skills needs
          as well as relevant policy and legislative frameworks.
        </p>

        <div class="downloads-panel">
          <div class="downloads-grid">
            <article v-for="(item, index) in reports" :key="'report-' + index" class="download-card">
              <div class="download-card__content">
                <h2 class="download-card__title">{{ item.title }}</h2>
                <p class="download-card__text">{{ item.description }}</p>
              </div>

              <a :href="item.file" class="download-card__button" target="_blank" rel="noopener noreferrer" download>
                <span>Download the document</span>
                <img :src="downloadIcon" alt="" class="download-card__icon" />
              </a>
            </article>
          </div>
        </div>
      </div>
    </section>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'
import downloadIcon from '../../assets/img/we-circular/download_1.svg'

export default {
  name: 'RegionalChallengesPage',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  data() {
    return {
      downloadIcon,
      reports: [
        {
          title: 'Joint Transnational Skills Needs Analysis',
          description:
            'The Transnational Skills Needs and Gaps Analysis synthesizes the current state of women entrepreneurs in twelve countries in the Danube region and their specific needs for circular and digital transitions. The analysis employs four methodological approaches to describe the situation and derive policy recommendations and conclusions.',
          file: 'https://vali.hu/static/Joint_Transnational_Skills_Needs_and_Gaps.pdf'
        },
        {
          title: 'Transnational Analysis – Policy and Legislative Framework',
          description:
            'The report on the analysis of policies and legislative framework summarizes and synthesizes the state of the existing policies when it comes to support of women entrepreneurship in transition to the circular economy process in twelve countries of the Danube region: Austria, Bosnia and Herzegovina, Bulgaria, Croatia, Czech Republic, Germany, Hungary, Moldova, Romania, Serbia, Slovakia and Slovenia.',
          file: 'https://vali.hu/static/Transnational_Analysis_Policy_and_Legislative.pdf'
        }
      ]
    }
  }
}
</script>

<style scoped>
.regional-challenges-page {
  min-height: 100vh;
  background: #f4f7f8;
  color: #123b66;
}

.page-section {
  width: 100%;
}

.page-container {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 40px 32px 64px;
  box-sizing: border-box;
}

.hero-section {
  padding-top: 24px;
}

.page-title {
  margin: 0 0 18px;
  font-size: 42px;
  line-height: 1.12;
  font-weight: 700;
  color: #0f4c97;
  text-align: left;
}

.page-intro {
  max-width: 760px;
  margin: 0 0 48px;
  font-size: 18px;
  line-height: 1.7;
  color: #4f6f8f;
  text-align: left;
}

.downloads-panel {
  position: relative;
  overflow: hidden;
  border-radius: 22px;
  background: linear-gradient(135deg, #0e5458 0%, #1a6669 55%, #2a7472 100%);
  box-shadow: 0 12px 30px rgba(10, 62, 67, 0.12);
}

.downloads-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 6% 20%, rgba(17, 94, 96, 0.95) 0, rgba(17, 94, 96, 0.95) 13%, transparent 14%)
      repeat-x,
    radial-gradient(circle at 20% 84%, rgba(120, 183, 176, 0.16) 0, rgba(120, 183, 176, 0.16) 11%, transparent 12%)
      repeat-x;
  background-size: 240px 120px, 210px 100px;
  opacity: 0.9;
  pointer-events: none;
}

.downloads-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 48px;
  padding: 42px 44px 58px;
}

.download-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* EZ A KULCS */
  height: 100%; /* fontos */
}

.download-card__content {
  display: flex;
  flex-direction: column;
  gap: 16px; /* egységes spacing */
  flex-grow: 1; /* kitolja a gombot */
}

.download-card__title {
  margin: 0;
  min-height: 96px;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 600;
  color: #ffffff;
  text-align: left;
}

.download-card__text {
  margin: 0;
  max-width: 490px;
  font-size: 17px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.92);
  text-align: left;
}

.download-card__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  align-self: flex-start;
  min-height: 48px;
  padding: 0 18px;
  border-radius: 8px;
  background: #0f4c97;
  color: #ffffff;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  margin-top: 24px; /* egységes távolság */
}

.download-card__button:hover {
  background: #0c3d79;
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 76, 151, 0.18);
}

.download-card__icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

@media (max-width: 1024px) {
  .page-title {
    font-size: 34px;
  }

  .downloads-grid {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 34px 30px 42px;
  }

  .download-card__title {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 30px 20px 48px;
  }

  .page-title {
    font-size: 30px;
  }

  .page-intro {
    margin-bottom: 34px;
    font-size: 17px;
    line-height: 1.7;
  }

  .downloads-grid {
    padding: 26px 20px 30px;
  }

  .download-card {
    min-height: unset;
  }

  .download-card__title {
    font-size: 22px;
  }

  .download-card__text {
    font-size: 15px;
    line-height: 1.7;
  }

  .download-card__button {
    width: 100%;
    justify-content: center;
    font-size: 15px;
  }
}
</style>
